import { cx } from '@linaria/core';
import { getCaptionValue } from '@pm2/content-engine';
import { pm2ConfigStore, usePM2DisplayContext } from '@pm2/store';
import { resets } from '@ui/css';
import { Tooltip } from '@ui/kit';
import { useResolvedDisplayData } from '../../hook.resolve-display-data.js';
import { componentWrapperCls } from './annotated-embed-iframe.style.js';
import { Footer } from './atoms/footer.js';
import { Header } from './atoms/header.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Boundary } from '../../molecules/embed-iframe/comp.boundary.js';
import { PostloadedIframe } from '../../molecules/embed-iframe/atom.postloaded-iframe.js';
import { IframeComponentContent } from '../../molecules/embed-iframe/comp.content.js';
import { Scrambled } from '../../molecules/embed-iframe/atom.scrambled.js';

const AnnotatedEmbedIframeComponentSelector = "annotated-embed-iframe-component";
function AnnotatedEmbedIframeComponent(props) {
  const loginDisabled = pm2ConfigStore.useSelector(state => state.config.settings.loginDisabled);
  const {
    inLightbox
  } = usePM2DisplayContext();
  const [displayData, failed, retry] = useResolvedDisplayData(props.getDisplayData, props.learningObjectId);

  // In case the component should be opened in cinemaMode, then do not bother
  // rendering anything aport from the iframe
  if (inLightbox && !props.isScrambled) {
    return /*#__PURE__*/jsx(Boundary, {
      hasPreviewImage: false,
      previewImageDimensions: undefined,
      forceOpenInLightbox: true,
      displayData: displayData,
      inLightbox: true,
      children: /*#__PURE__*/jsx(PostloadedIframe, {
        src: displayData?.src,
        title: getCaptionValue(props.caption.title, "in-context")
      })
    });
  }
  let content;
  if (props.isScrambled) {
    content = /*#__PURE__*/jsx(Scrambled, {});
  } else {
    content = /*#__PURE__*/jsx(IframeComponentContent, {
      title: getCaptionValue(props.caption.title, "in-context"),
      learningObjectId: props.learningObjectId,
      autoActivate: props.autoActivate ?? false,
      target: props.target,
      displayData: displayData,
      retryFetchingDisplayData: retry,
      failedFetchingDisplayData: failed,
      contentType: props.contentType
    });
  }
  return /*#__PURE__*/jsx(Tooltip, {
    disabled: !loginDisabled,
    placement: "top",
    body: "Denne funktion kan ikke tilg\xE5s i \xF8jeblikket, da vi har problemer med login.",
    ariaType: "description",
    children: ref => /*#__PURE__*/jsxs("section", {
      ref: ref,
      "data-component-type": AnnotatedEmbedIframeComponentSelector,
      className: cx("gIframe", resets.rootCls, componentWrapperCls),
      children: [/*#__PURE__*/jsx(Header, {
        title: props.displayTitle === "above" ? getCaptionValue(props.caption.title, "in-context") : undefined,
        description: props.displayCaption === "above" ? getCaptionValue(props.caption.description, "in-context") : undefined,
        scrambled: props.isScrambled
      }), content, props.displayCaption !== undefined && /*#__PURE__*/jsx(Footer, {
        includeTitle: props.displayTitle === "below",
        caption: props.caption,
        scrambled: props.isScrambled
      })]
    })
  });
}

export { AnnotatedEmbedIframeComponent, AnnotatedEmbedIframeComponentSelector };
//# sourceMappingURL=annotated-embed-iframe.js.map
